  <section id="GovernanceLockSection" class="governance-section py-5">
    <div class="container py-5">

      <!-- Kicker -->
      <div class="d-flex justify-content-center mb-3">
        <div class="d-flex align-items-center gap-3 text-uppercase text-xs fw-semibold governance-kicker">
          <span class="governance-kicker-line"></span>
          <span>{{ governance_data.kicker }}</span>
        </div>
      </div>

      <!-- Title -->
      <h2 class="text-center governance-title mb-3">
        {{ governance_data.title }}
      </h2>

      <!-- Subtext -->
      <p class="text-center governance-lead mx-auto mb-5">
        {{ governance_data.description }}
      </p>

      <!-- Cards -->
      <div class="row g-4 justify-content-center">
        <div
          v-for="card in governance_cards"
          :key="card.key"
          class="col-12 col-md-6 col-lg-4"
        >
          <div class="card governance-card border-0 h-100">
            <div class="card-body text-center p-4 p-lg-5">

              <!-- Icon bubble -->
              <div class="governance-icon-wrap mx-auto mb-4 d-flex align-items-center justify-content-center">
                <!-- Using inline SVG so you don't need external icon libs -->
                <span class="d-inline-flex align-items-center justify-content-center">
                  <svg
                    v-if="card.icon === 'oversight'"
                    class="governance-icon"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M4 10.5 12 4l8 6.5V20a1 1 0 0 1-1 1h-5v-7H10v7H5a1 1 0 0 1-1-1v-9.5Z" fill="none" stroke="currentColor" stroke-width="1.5" />
                    <path d="M9 21v-7h6v7" fill="none" stroke="currentColor" stroke-width="1.5" />
                  </svg>

                  <svg
                    v-else-if="card.icon === 'lock'"
                    class="governance-icon"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M7 10V8a5 5 0 0 1 10 0v2" fill="none" stroke="currentColor" stroke-width="1.5" />
                    <path d="M6.5 10h11A1.5 1.5 0 0 1 19 11.5v8A1.5 1.5 0 0 1 17.5 21h-11A1.5 1.5 0 0 1 5 19.5v-8A1.5 1.5 0 0 1 6.5 10Z" fill="none" stroke="currentColor" stroke-width="1.5" />
                  </svg>

                  <svg
                    v-else
                    class="governance-icon"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M12 3 20 7v6c0 5-3.6 8.3-8 9-4.4-.7-8-4-8-9V7l8-4Z" fill="none" stroke="currentColor" stroke-width="1.5" />
                    <path d="M9.5 12.2 11 13.7l3.6-4" fill="none" stroke="currentColor" stroke-width="1.5" />
                  </svg>
                </span>
              </div>

              <!-- Title -->
              <h5 class="governance-card-title mb-3">
                {{ card.title }}
              </h5>

              <!-- Copy -->
              <p class="governance-card-text mb-0">
                {{ card.description }}
              </p>

            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
